module.exports = __webpack_public_path__ + "media/flags/nato-ee323b9a.svg";